import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';
import { useNavigate, useParams } from 'react-router-dom';
import { Card, CardBody, CardHeader, Col, Container, Row } from 'reactstrap';
import { Helmet } from 'react-helmet-async';
import dayjs from 'dayjs';

import { MLButton } from 'components/Button/Button';
import { getPeriodReports } from 'api/periodReports/getPeriodReports';
import VulnerabilityAccordion from 'components/PeriodReportAccordions/VulnerabilityAccordion/VulnerabilityAccordion';
import EncounterAccordion from 'components/PeriodReportAccordions/EncounterAccordion/EncounterAccordion';
import TrapsDataAccordion from 'components/PeriodReportAccordions/TrapsData/TrapsDataAccordion';
import { TrapTimeLineChart } from 'pages/VisitReports/Charts/TrapsTimeLineChart';
import { SBSChart } from 'pages/VisitReports/Charts/SBSChart';
import { TrapType } from 'components/AnalyticsPage/TrapType';

const PeriodDocs = () => {
  let { slug, id } = useParams();
  const { t } = useTranslation();
  const { data } = useQuery('periodDocs', () => getPeriodReports({ slug: slug || '', id: id || '' }), {});
  const navigate = useNavigate();

  return (
    <div className="page-content bg-light">
      <Helmet>
        <title>
          {t('PeriodReports.page-title')}
          {' | Trojan - CRM'}
        </title>
      </Helmet>
      <Container fluid>
        <Card>
          <CardHeader>
            <Row className="align-items-center">
              <Col lg={9}>
                <div className="text-start">
                  <h4 className="card-title mb-0 fs-20">
                    {`${t('PeriodReports.page-desc')} ${dayjs(data?.start_date).format('DD.MM.YYYY')} - ${dayjs(data?.end_date).format('DD.MM.YYYY')}`}
                  </h4>
                </div>
              </Col>
              <Col lg={3} className="d-flex justify-content-end">
                <MLButton
                  innerText={t('PeriodReports.button.but-title')}
                  color="purple"
                  fontSize={18}
                  icon="ri-file-pdf-fill fs-16"
                  isGhost
                  onClick={() => {
                    navigate(`/period-report/${slug}/${id}/check/`);
                  }}
                />
              </Col>
            </Row>
          </CardHeader>
          <CardBody>
            <div className="row border-bottom-dashed border-light my-3" />
            {data?.start_date && data?.end_date && (
              <TrapTimeLineChart
                slug={slug || ''}
                trapType={TrapType.MCT}
                startDate={data.start_date}
                endDate={data.end_date}
              />
            )}
            <div className="row border-bottom-dashed border-light my-3" />
            <EncounterAccordion encounters={data?.encounter_list || []} />
            <TrapsDataAccordion trap_data_list={data?.trap_data_list || []} />
            <VulnerabilityAccordion vul_data_list={data?.vulnetability_list || []} />
            <div className="row border-bottom-dashed border-light my-3" />
            {data?.start_date && data?.end_date && (
              <SBSChart slug={slug || ''} startDate={data.start_date} endDate={data.end_date} />
            )}
            <div className="row border-bottom-dashed border-light my-3" />
          </CardBody>
        </Card>
      </Container>
    </div>
  );
};

export default PeriodDocs;
